export default __webpack_public_path__ + "static/media/booksImage.28e3eb36.png";